"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useEffect, type KeyboardEvent } from "react";
import { useTranslations } from "next-intl";
import { Icon } from "@repo/ui/icon";
interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: (query: string) => void;
  onClose: () => void;
  placeholder?: string;
  autoFocus?: boolean;
}
export function SearchInput(t0) {
  const $ = _c(38);
  const {
    value,
    onChange,
    onSubmit,
    onClose,
    placeholder,
    autoFocus: t1
  } = t0;
  const autoFocus = t1 === undefined ? true : t1;
  const t = useTranslations("search");
  const inputRef = useRef(null);
  let t2;
  if ($[0] !== placeholder || $[1] !== t) {
    t2 = placeholder ?? t("inputPlaceholder");
    $[0] = placeholder;
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const resolvedPlaceholder = t2;
  let t3;
  let t4;
  if ($[3] !== autoFocus) {
    t3 = () => {
      if (autoFocus) {
        const timer = setTimeout(() => {
          inputRef.current?.focus();
        }, 50);
        return () => clearTimeout(timer);
      }
    };
    t4 = [autoFocus];
    $[3] = autoFocus;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== onClose || $[7] !== onSubmit || $[8] !== value) {
    t5 = function handleKeyDown(e) {
      if (e.key === "Enter" && value.trim()) {
        onSubmit(value.trim());
      }
      if (e.key === "Escape") {
        onClose();
      }
    };
    $[6] = onClose;
    $[7] = onSubmit;
    $[8] = value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleKeyDown = t5;
  let t6;
  if ($[10] !== onChange) {
    t6 = function handleClear() {
      onChange("");
      inputRef.current?.focus();
    };
    $[10] = onChange;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleClear = t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon name="search" size="lg" className="flex-shrink-0 text-text-primary" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== onChange) {
    t8 = e_0 => onChange(e_0.target.value);
    $[13] = onChange;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t("inputAriaLabel");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== handleKeyDown || $[18] !== resolvedPlaceholder || $[19] !== t8 || $[20] !== t9 || $[21] !== value) {
    t10 = <input ref={inputRef} type="text" value={value} onChange={t8} onKeyDown={handleKeyDown} placeholder={resolvedPlaceholder} className="flex-1 bg-transparent text-text-primary typography-component-sm-medium placeholder:text-text-disabled outline-none" aria-label={t9} role="searchbox" autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck={false} />;
    $[17] = handleKeyDown;
    $[18] = resolvedPlaceholder;
    $[19] = t8;
    $[20] = t9;
    $[21] = value;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== handleClear || $[24] !== t || $[25] !== value) {
    t11 = value && <button type="button" onClick={handleClear} className="flex-shrink-0 flex items-center justify-center rounded-full bg-button-primary-background text-button-primary-text h-6 w-6 hover:bg-button-primary-background-hover transition-colors" aria-label={t("clearSearch")}><Icon name="close" size="sm" /></button>;
    $[23] = handleClear;
    $[24] = t;
    $[25] = value;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <div className="relative flex flex-1 items-center gap-3 rounded-full border border-border-subtle px-4 py-2.5 focus-within:border-border-interactive transition-colors">{t7}{t10}{t11}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t) {
    t13 = t("close");
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== onClose || $[33] !== t13) {
    t14 = <button type="button" onClick={onClose} className="flex-shrink-0 typography-component-xs-medium text-text-primary hover:text-text-secondary transition-colors">{t13}</button>;
    $[32] = onClose;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t12 || $[36] !== t14) {
    t15 = <div className="flex items-center gap-3 flex-1">{t12}{t14}</div>;
    $[35] = t12;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  return t15;
}